/**
 * CLE-3000 — the cache tag the Service Type rules' evaluate answers provide
 * (`practiceTypeSuggestion.ts`). A CPT group range write (`procedureModalityRange.ts`, Eligibility ›
 * CPT Groups) invalidates it, because which group a code is in decides which rule fires. Its own
 * file so neither query file imports the other.
 */
export const PRACTICE_TYPE_EVALUATE_TAG = {
  type: "PracticeTypeSuggestionRules" as const,
  id: "EVALUATE",
};
